.footer-menu-type-1 {
  .me-button {
    display: inline-flex;
    margin: var(--spacing-xs) 0;
  }
}

.footer-menu-type-1__items {
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 0;
  }

  .me-button {
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, normal);
  }
}
